import React, { useState } from 'react';
import axios from 'axios';

const API_URL = '/api';

function UserModal({ user, facilities, token, onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    username: user?.username || '',
    password: '',
    role: user?.role || 'user',
    facilities: user?.facilities?.map(f => f._id || f) || [],
    isActive: user?.isActive !== undefined ? user.isActive : true
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const data = {
      username: formData.username,
      role: formData.role,
      facilities: formData.facilities,
      isActive: formData.isActive
    };

    if (formData.password) {
      data.password = formData.password;
    }

    try {
      if (user) {
        await axios.put(`${API_URL}/users/${user._id}`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Kullanıcı güncellendi');
      } else {
        if (!formData.password) {
          alert('Şifre gerekli');
          return;
        }
        data.password = formData.password;
        await axios.post(`${API_URL}/users`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
        alert('Kullanıcı eklendi');
      }
      onSuccess();
    } catch (err) {
      alert('Hata: ' + err.response?.data?.error);
    }
  };

  const toggleFacility = (facilityId) => {
    if (formData.facilities.includes(facilityId)) {
      setFormData({
        ...formData,
        facilities: formData.facilities.filter(f => f !== facilityId)
      });
    } else {
      setFormData({
        ...formData,
        facilities: [...formData.facilities, facilityId]
      });
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <h3>{user ? '✏️ Kullanıcı Düzenle' : '➕ Yeni Kullanıcı Ekle'}</h3>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>KULLANICI ADI *</label>
            <input
              type="text"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>ŞİFRE {!user && '*'}</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              placeholder={user ? 'Değiştirmek için girin' : 'Şifre'}
              required={!user}
            />
          </div>

          <div className="form-group">
            <label>ROL</label>
            <select
              value={formData.role}
              onChange={(e) => setFormData({...formData, role: e.target.value})}
            >
              <option value="user">Kullanıcı</option>
              <option value="admin">Admin</option>
            </select>
          </div>

          <div className="form-group">
            <label>ERİŞEBİLECEĞİ TESİSLER</label>
            <div style={{display: 'grid', gap: '10px', marginTop: '10px'}}>
              {facilities.map(facility => (
                <label key={facility._id} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '10px',
                  background: '#1D1D1D',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}>
                  <input
                    type="checkbox"
                    checked={formData.facilities.includes(facility._id)}
                    onChange={() => toggleFacility(facility._id)}
                  />
                  <span>{facility.facilityName}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="form-group">
            <label style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
              <input
                type="checkbox"
                checked={formData.isActive}
                onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
              />
              HESAP AKTİF
            </label>
          </div>

          <div className="modal-actions">
            <button type="submit" className="btn">
              {user ? 'GÜNCELLE' : 'EKLE'}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">
              İPTAL
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserModal;
